export default {"src":"/_next/static/media/gallery-and-text.32afdb7a.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};